import getCharts from '../getCharts'
import { TaskCRUD } from '../../constants/api.config'
import { formatValueToMMDDYYYY } from '../../components/shared/customDateFormatUtils'

const safeJsonString = (value) => {
    if (typeof value === 'string') return value.trim() ? value : '[]'
    try {
        return JSON.stringify(value ?? [])
    } catch (err) {
        console.error('Safe JSON stringify failed:', err)
        return '[]'
    }
}

const stringifyValue = (value) => {
    if (value === null || value === undefined) return ''
    return String(value)
}

const stringifyNumericValue = (value, defaultValue = '') => {
    if (value === null || value === undefined || value === '') return defaultValue
    return String(value)
}

const firstDefined = (...values) =>
    values.find((value) => value !== undefined && value !== null)

const normalizeJsonPayload = (...values) =>
    safeJsonString(firstDefined(...values))

const normalizeBooleanValue = (value) => {
    if (value === true || value === 1) return true
    if (typeof value === 'string') return value.trim().toLowerCase() === 'true'
    return false
}

const normalizeTaskDate = (value) => formatValueToMMDDYYYY(value) || stringifyValue(value)

export default async function SaveTasks(paramsOrAction = {}, taskId = null, boardId = null, payload = {}) {
    const args =
        typeof paramsOrAction === 'string' || typeof paramsOrAction === 'number'
            ? {
                  action: paramsOrAction,
                  taskId,
                  boardId,
                  ...payload,
              }
            : paramsOrAction || {}

    const taskData = args.taskData || args.payload || args.data || {}
    const normalizedArgs =
        taskData && typeof taskData === 'object' && !Array.isArray(taskData)
            ? {
                  ...taskData,
                  ...args,
              }
            : args

    const {
        action,
        mode,
        taskId: argTaskId = null,
        TaskId = null,
        id = null,
        boardId: argBoardId = null,
        BoardId = null,
        taskType = '',
        TaskType = '',
        title = '',
        Title = '',
        description = '',
        Description = '',
        statusId = null,
        StatusId = null,
        status = '',
        Status = '',
        priority = '',
        Priority = '',
        dueDate = '',
        DueDate = '',
        reminderDate = '',
        ReminderDate = '',
        createdBy = null,
        CreatedBy = null,
        createdById = null,
        userId = null,
        linkedLabsJson,
        LinkedLabsJson,
        linkedMedicationsJson,
        LinkedMedicationsJson,
        linkedImagingsJson,
        LinkedImagingsJson,
        tagsJson,
        TagsJson,
        commentsJson,
        CommentsJson,
        activityLogsJson,
        ActivityLogsJson,
        watchersJson,
        WatchersJson,
        assignedUsersJson,
        AssignedUsersJson,
        subtasksJson,
        SubtasksJson,
        labs,
        linkedLabs,
        medications,
        linkedMedications,
        imagings,
        linkedImagings,
        tags,
        Tags,
        comments,
        Comments,
        logs,
        activities,
        watchers,
        Watchers,
        assignedUsers,
        AssignedUsers,
        assignees,
        Assignee,
        assignee,
        subTasks,
        subtasks,
        subtask,
        attachmentsJson,
        AttachmentsJson,
        attachments,
        files,
        Files,
        isArchived,
        IsArchived
    } = normalizedArgs

    const actionType = stringifyValue(firstDefined(action, mode)).toUpperCase()
    const taskIdValue = stringifyNumericValue(firstDefined(argTaskId, TaskId, id), '0')
    const boardIdValue = stringifyNumericValue(firstDefined(argBoardId, BoardId), '')

    try {
        const payload = {
            action: actionType,
            taskId: taskIdValue,
            TaskId: taskIdValue,
            boardId: boardIdValue,
            BoardId: boardIdValue,
            taskType: stringifyValue(firstDefined(taskType, TaskType)),
            TaskType: stringifyValue(firstDefined(taskType, TaskType)),
            title: stringifyValue(firstDefined(title, Title)),
            description: stringifyValue(firstDefined(description, Description)),
            statusId: stringifyNumericValue(firstDefined(statusId, StatusId), ''),
            StatusId: stringifyNumericValue(firstDefined(statusId, StatusId), ''),
            status: stringifyValue(firstDefined(status, Status)),
            Status: stringifyValue(firstDefined(status, Status)),
            priority: stringifyValue(firstDefined(priority, Priority)),
            dueDate: normalizeTaskDate(firstDefined(dueDate, DueDate)),
            reminderDate: normalizeTaskDate(firstDefined(reminderDate, ReminderDate)),
            createdBy: stringifyValue(firstDefined(createdBy, CreatedBy, createdById, userId)),
            linkedLabsJson: normalizeJsonPayload(linkedLabsJson, LinkedLabsJson, linkedLabs, labs),
            linkedMedicationsJson: normalizeJsonPayload(linkedMedicationsJson, LinkedMedicationsJson, linkedMedications, medications),
            linkedImagingsJson: normalizeJsonPayload(linkedImagingsJson, LinkedImagingsJson, linkedImagings, imagings),
            tagsJson: normalizeJsonPayload(tagsJson, TagsJson, Tags, tags),
            commentsJson: normalizeJsonPayload(commentsJson, CommentsJson, Comments, comments),
            activityLogsJson: normalizeJsonPayload(activityLogsJson, ActivityLogsJson, activities, logs),
            watchersJson: normalizeJsonPayload(watchersJson, WatchersJson, Watchers, watchers),
            assignedUsersJson: normalizeJsonPayload(
                assignedUsersJson,
                AssignedUsersJson,
                AssignedUsers,
                assignedUsers,
                assignees,
                Assignee,
                assignee
            ),
            subtasksJson: normalizeJsonPayload(subtasksJson, SubtasksJson, subTasks, subtasks, subtask),
            attachmentsJson: normalizeJsonPayload(attachmentsJson, AttachmentsJson, attachments, files, Files),
            isArchived: normalizeBooleanValue(firstDefined(isArchived, IsArchived)),
        }

        console.log('TaskCRUD payload:', payload)

        const res = await getCharts(TaskCRUD, payload)

        console.log('TaskCRUD response:', res)

        return res.data
    } catch (error) {
        console.error('TaskCRUD error:', error)

        return error
    }
}
